import { FormEvent, useState } from 'react';
import type { SignupRequest, SignupResult } from '@kassa/shared';
import { api, ApiError } from '../api';

// «Pulsuz sınaq» — öz qeydiyyatı (KT-85). Şirkət burada yaranmır: e-poçta link gedir (və ya admin təsdiqindən sonra),
// link e-poçtu təsdiqləyir və qeydiyyatın qalanını açır (parol və ya Google, ilk obyekt, ƏDV, şərtlər).
// «website» sahəsi gizli tələdir (insan görmür, boş qalır). Kənar captcha yoxdur.

const SECTORS: [SignupRequest['sector'], string][] = [
  ['market', 'Market'], ['wholesale', 'Topdan'], ['agro', 'Aqro'], ['restaurant', 'Restoran'], ['clothing', 'Geyim'], ['service', 'Xidmət'],
];

const EMPTY = { ownerName: '', email: '', phone: '', companyName: '', sector: '' as '' | SignupRequest['sector'], voen: '', website: '' };

export function Signup({ trialDays, onBack }: { trialDays: number; onBack: () => void }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState<SignupResult['status'] | null>(null);
  const set = (k: keyof typeof EMPTY, v: string) => setF((x) => ({ ...x, [k]: v }));

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (!f.sector) return setError('Fəaliyyət növünü seçin');
    setBusy(true);
    setError(null);
    try {
      const r = await api.signup({
        ownerName: f.ownerName, email: f.email, phone: f.phone, companyName: f.companyName, sector: f.sector,
        voen: f.voen || undefined, website: f.website || undefined,
      });
      setDone(r.status);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Şəbəkə xətası. Yenidən cəhd edin.');
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <div className="auth-form">
        <div className="auth-heading">
          <h2>{done === 'invited' ? 'E-poçtunuzu yoxlayın' : 'Müraciət qəbul olundu'}</h2>
        </div>
        <p role="status">
          {done === 'invited'
            ? `${f.email} ünvanına link göndərdik. Linki açın — e-poçt təsdiqlənəcək, parol (və ya Google) seçib ilk obyekti yazacaqsınız.`
            : `Müraciətinizi yoxlayıb ${f.email} ünvanına link göndərəcəyik.`}
        </p>
        <p className="muted small">Məktub gəlməyibsə, «Spam» qovluğuna baxın.</p>
        <button type="button" className="link-btn" onClick={onBack}>
          Girişə qayıt
        </button>
      </div>
    );
  }

  return (
    <form className="auth-form" onSubmit={submit} noValidate>
      <div className="auth-heading">
        <h2>Pulsuz sınaq — {trialDays} gün</h2>
        <span className="muted">Kart və ödəniş tələb olunmur. Sınaq bitəndə də kassa işləyir.</span>
      </div>
      <label className="field">
        Adınız
        <input autoComplete="name" maxLength={120} value={f.ownerName} onChange={(e) => set('ownerName', e.target.value)} disabled={busy} />
      </label>
      <label className="field">
        E-poçt
        <input type="email" autoComplete="email" maxLength={254} value={f.email} onChange={(e) => set('email', e.target.value)} disabled={busy} />
      </label>
      <label className="field">
        Telefon
        <input type="tel" autoComplete="tel" placeholder="+994 50 000 00 00" maxLength={24} value={f.phone} onChange={(e) => set('phone', e.target.value)} disabled={busy} />
      </label>
      <label className="field">
        Şirkətin (mağazanın) adı
        <input autoComplete="organization" maxLength={200} value={f.companyName} onChange={(e) => set('companyName', e.target.value)} disabled={busy} />
      </label>
      <label className="field">
        Fəaliyyət növü
        <select value={f.sector} onChange={(e) => set('sector', e.target.value)} disabled={busy}>
          <option value="">Seçin…</option>
          {SECTORS.map(([k, v]) => (
            <option key={k} value={k}>{v}</option>
          ))}
        </select>
      </label>
      <label className="field">
        VÖEN (könüllü)
        <input inputMode="numeric" maxLength={10} value={f.voen} onChange={(e) => set('voen', e.target.value.replace(/\D/g, ''))} disabled={busy} />
      </label>
      {/* Tələ: ekran oxuyucusundan və klaviaturadan da gizli */}
      <div className="hp-field" aria-hidden="true">
        <label>
          Sayt
          <input tabIndex={-1} autoComplete="off" value={f.website} onChange={(e) => set('website', e.target.value)} />
        </label>
      </div>
      {error && (
        <p className="bad" role="alert">
          {error}
        </p>
      )}
      <button
        type="submit"
        className="btn-primary"
        disabled={busy || !f.ownerName.trim() || !f.email.trim() || !f.phone.trim() || !f.companyName.trim()}
      >
        {busy ? 'Göndərilir…' : 'Sınağa başla'}
      </button>
      <button type="button" className="link-btn" onClick={onBack}>
        Hesabım var — daxil ol
      </button>
    </form>
  );
}
